<!-- E:\workspace_yongli\as_client\src\pages\system\position_level_edit.vue -->
<template>
    <c-dialog
            ref="dialog"
            :title="editFlag ? '编辑岗位级别' : '创建岗位级别'"
            width="500"
            mode="slide"
            @resolve="submitHandle"
    >
        <c-form ref="form" column="1" vertical unit-width="100%">
            <c-input type="hidden" name="id"></c-input>

            <c-form-item label="职级名称" required>
                <c-input name="level_name" placeholder="请输入岗位级别名称"></c-input>
            </c-form-item>

            <c-form-item label="职级排序" required>
                <c-input name="sort" type="number" placeholder="数值越小级别越高"></c-input>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
export default {
    data() {
        return {
            editFlag: false,
            currentData: null
        }
    },

    methods: {
        open(data) {
            this.currentData = data;
            this.editFlag = !!data;

            this.$refs.form.clear();

            if (data) {
                this.$refs.form.set(data);
            }

            this.$refs.dialog.open();
        },

        submitHandle(stop, next) {
            stop();

            this.$refs.form.submit({
                url: this.editFlag ? '/position_level/edit' : '/position_level/add',
                rule: {
                    level_name: '请填写岗位级别名称',
                    sort: '请填写排序值'
                },
                dataFormatter: (data) => {
                    // 如果是编辑，保留原ID
                    if (this.editFlag && this.currentData) {
                        data.id = this.currentData.id;
                    }
                    return data;
                },
                success: (data, res) => {
                    next();
                    this.$message({
                        message: this.editFlag ? '编辑成功' : '创建成功',
                        type: 'success'
                    });
                    this.$emit('resolve', res);
                },
                error: (error) => {
                    console.error('保存失败:', error);
                    this.$message({
                        message: error.message || '保存失败，请重试',
                        type: 'error'
                    });
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>
